// extracted by mini-css-extract-plugin
module.exports = {"Container":"Overview_Container__7nnpU","Row":"Overview_Row__180qm","About":"Overview_About__3iVme"};